import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { TtIcon } from '@23/ui-react'

import IconComponent from '../../sharedLegacy/components/IconComponent/IconComponent'
import { useWebinarColors } from '../../Designs/blocs/useWebinarColors'

import { usePollsContext } from './PollsContext'

import './PollAnswered.scss'

export const PollAnswered = () => {
  const { renderPollUnitWrapper } = usePollsContext()
  const { accent, sidebar } = useWebinarColors()

  const [isClosed, setIsClosed] = useState(false)

  if (isClosed) {
    return null
  }

  const content = (
    <div className="poll-answered-component">
      <div className="check-icon-wrapper">
        <IconComponent
          name="check"
          size={[16, 16]}
          color={accent.color.replace('#', '')}
        />
      </div>
      <div className="message">
        <FormattedMessage defaultMessage="Thank you for your answer." />
      </div>
      <div className="close-message">
        <TtIcon
          style={{ color: sidebar.highContrast.transparent('25%') }}
          name="close"
          onClick={() => setIsClosed(true)}
        />
      </div>
    </div>
  )

  return renderPollUnitWrapper
    ? renderPollUnitWrapper({ children: content })
    : content
}
